<template>
  <div class="select-device-box">
    <div class="content-box">
      <h1 class="item-title" style="margin: 16px 0 0">{{ $t('asm_offlineService_select_device.tong_xun_banSN') }}{{ data.modemSn }}</h1>
      <!-- :slots="taskStrategy==='2'?['taskDesc','firmwareVersion']:['taskDesc']" -->
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <!-- 配置项 -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
          </el-form-item>
          <!-- 搜索项 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('asm_offlineService_select_device.ji_shen_haoModemSN')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
          <el-form-item style="float: right">
            <switch-button :link="$refs.container"></switch-button>
          </el-form-item>
          <!-- <el-form-item style="float: right;">
            <div class="info">
              共<span class="default">{{totalRows}}</span>条数据，验证通过<span class="default">{{checkSuccessNum}}</span>条，未通过<span class="caveat">{{checkFailureNum}}</span>条
            </div>
          </el-form-item>-->
        </el-form>
      </div>
      <switch-container ref="container" @search="onSearch" @clear="clearFilter()">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('asm_offlineService_select_device.he_tong_bian_hao')">
            <!-- <custom-select v-model="formSearch.afterServiceId" placeholder="" url="partnerFactoryServiceList" :props="{ label: 'partnerName', value: 'partnerOrgId' }"></custom-select> -->
            <el-input v-model="formSearch.contractNo" placeholder=""></el-input>
          </el-form-item>
          <el-form-item :label="$t('asm_offlineService_select_device.shou_hou_gong_si')">
            <!-- <custom-select v-model="formSearch.afterServiceId" placeholder="" url="partnerFactoryServiceList" :props="{ label: 'partnerName', value: 'partnerOrgId' }"></custom-select> -->
            <el-input v-model="formSearch.afterServiceName" placeholder=""></el-input>
          </el-form-item>
          <el-form-item :label="$t('asm_offlineService_select_device.dai_li_gong_si')">
            <!-- <custom-select v-model="formSearch.agentCoId" :props="{ label: 'label', value: 'value' }" placeholder="" url="partnerSelectAgent"></custom-select> -->
            <el-input v-model="formSearch.agentCoName" placeholder=""></el-input>
          </el-form-item>
          <el-form-item :label="$t('asm_offlineService_select_device.zu_lin_fang')">
            <!-- <custom-select v-model="formSearch.customerId" :props="{ label: 'label', value: 'value' }" placeholder="" url="partnerSelectCustomer"></custom-select> -->
            <el-input v-model="formSearch.customerName" placeholder=""></el-input>
          </el-form-item>
          <el-form-item :label="$t('asm_offlineService_select_device.xiang_mu_ming_cheng')">
            <el-input v-model="formSearch.locationName"></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd">
        <custom-table
          :data="deviceList"
          ref="customTb1"
          v-model="tableSelect"
          type="radio"
          height="100%"
          :loading="isLoading"
          :index="true"
          :column="tableColumn"
          @filter="filterChange"
          @sort="sortChange"
        ></custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">
        {{ i18n.com_cancel }}
      </el-button>
      <el-button type="primary" @click="saveTask">{{ $t('asm_offlineService_select_device.xybxzxfzl') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import languageInjectMixins from '@/mixins/language_inject_mixins';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';

export default {
  mixins: [languageInjectMixins, resetFormSearchMixins],
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: '',
        };
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
    data: [String, Object, Array],
    taskId: [String, Number],
    firmwareId: [String, Number],
  },
  components: {
  },
  data() {
    return {
      tableCode: 'offline_service_device',
      // 分页
      formSearch: {
        search: '',
        taskName: '',
        pageSize: 50,
        pageNum: 1,
        taskId: '',

        // 高级搜索
        //  售后公司
        afterServiceName: '',
        // 代理公司
        agentCoName: '',
        // 租赁方
        customerName: '',
        // 设备使用地址
        useLocation: '',
      },
      totalRows: null,
      deviceList: [],
      versionListSelect: [],
      tableColumnVersion: null,
      checkSuccessNum: 0,
      checkFailureNum: 0,

      taskStrategy: '',
      controlMode: '',

      // 新增设备
      dialogVisible: false,
      dialogData: {},
      dialogModel: {},
    };
  },
  mounted() {
    this.isLoading = true;
    this.getTableColumn();
    this.getDeviceList();
  },
  methods: {
    onCancel() {
      this.$router.back();
    },

    getDeviceList: function () {
      // 获取表格列
      this.formSearch.taskId = this.taskId;
      // 第二步选择合同
      this.$getJSON(apis.MyDeviceBizPage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.deviceList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },

    onSearch() {
      this.onPageChange({ page: 1 });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDeviceList();
    },

    // 保存
    saveTask: function () {
      if (JSON.stringify(this.tableSelect) === '{}') {
        this.$message.error(this.$t('asm_offlineService_select_device.qnxxzsb'));
        return;
      }
      this.$postJSON(`${apis.serviceModemRecordSave}`, {
        bodyNum: this.tableSelect.bodyNum,
        productCode: this.tableSelect.productCode,
        modemSn: this.data.modemSn,
        serviceModemId: this.data.serviceModemId,
      })
        .then((res) => {
          this.$emit('success', res.data);
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.select-device-box {
  display: flex;
  height: 100%;
  background-color: #ffffff;
  flex-direction: column;
  padding: 0 24px;
  box-sizing: border-box;

  .green {
    color: #67c23a;
  }

  .red {
    color: #f56c6c;
  }

  .content-box {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .btn-group {
    border-top: 1px solid #eef2f8;
    padding: 16px 0 16px 24px;
    height: 60px;
    z-index: 1;
    -webkit-box-flex: 0;
    flex: 0 0 60px;
  }
  .info {
    color: #6c757d;
    .default {
      color: $main-color;
    }
    .caveat {
      color: #ff5c5b;
    }
  }
}
</style>
